// Typed wrapper around GET /v1/usage. The endpoint returns plan + period
// totals + per-agent breakdown + daily series + plan caps in one shot —
// the Usage page renders all of those, so a single round trip is enough.

import type { UsageSummary } from '@cortex/shared';
import type { ApiClient } from '../api-client.js';

export const usageApi = {
  summary: (api: ApiClient) => api.get<UsageSummary>('/v1/usage'),
} as const;

export const USAGE_QUERY_KEY = ['usage'] as const;
